"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const utils_1 = require("../utils");
const LOCK_TIME = 5; // in mins
/**
 * Add locking time to order, should expire after cetain limit
 * @param event
 * @param prevState
 */
function default_1(event, prevState = {}) {
    let order = (0, utils_1.clone)(prevState);
    order.lock = {
        expiresAt: event.timestamp + LOCK_TIME * 60 * 1000,
    };
    return order;
}
exports.default = default_1;
//# sourceMappingURL=orderLock.js.map